<template>
  <div v-if="!isClosed">
    <FirstStep v-if="currentStep === 1"/>
    <SubmitStep v-if="currentStep === 2"/>
    <SuccessStep :iconChecked="iconChecked" v-if="currentStep === 4"/>
  </div>
</template>

<script>
import FirstStep from "@/modules/Dashboard/components/NewDashboard/SurveyOnBoard/FirstStep";
import SubmitStep from "@/modules/Dashboard/components/NewDashboard/SurveyOnBoard/SubmitStep";
import SuccessStep from "@/modules/Dashboard/components/NewDashboard/SurveyOnBoard/SuccessStep";
import {mapActions, mapGetters, mapState} from "vuex";
import {actions as obActions} from "@/store/newonboarding/types";

export default {
  name: "Index",
  components: {
    FirstStep,
    SubmitStep,
    SuccessStep
  },
  data: () => ({
    step: 1,
    iconChecked: require("@/core/assets/new-dashboard/onboard/checked-icon.svg")
  }),
  computed: {
    ...mapGetters("newonboarding", {
      currentStep: "currentStep",
      isClosed: "isClosed"
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
  },
  mounted() {
    this.checkSurveyOnboard();
  },
  methods: {
    checkSurveyOnboard() {
      const {surveys} = this.shopInfo;
      if (surveys.length > 0) {
        const surveysSize = surveys.length;
        let foundWidgetSurvey = false;
        for (let i = 0; i < surveysSize; i++) {
          const item = surveys[i];
          const handle = item.handle;
          const status = item.status;
          if (handle === "dashboard-widget-survey" && status === "done") {
            foundWidgetSurvey = true;
            break;
          }
        }
        // If have no found, then show it
        if (!foundWidgetSurvey) {
          this.openWidgetOnBoarding();
        }
      } else {
        this.openWidgetOnBoarding();
      }
    },
    ...mapActions("newonboarding", {
      openWidgetOnBoarding: obActions.OPEN_WIDGET_ON_BOARDING
    }),
  },
}
</script>

<style lang="scss" scoped>
.main-height {
  position: relative;
  height: 390px;
}
</style>
<style>
.btn-new-onboard-survey {
  width: calc(100% - 32px);
  position: absolute;
  bottom: 16px;
  margin-left: 16px;
  font-size: 12px;
}
</style>
